export default __webpack_public_path__ + "static/media/homePage_secondContent.d2659009.jpg";